import { API, Auth } from 'aws-amplify'
import React, { useState } from 'react'
import "bootstrap/dist/css/bootstrap.css";
import { Table } from '@aws-amplify/ui-react';
import QueryRow from './QueryRow';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { Search } from 'react-bootstrap-icons';
import Spinner from 'react-bootstrap/Spinner';
import Dropdown from 'react-bootstrap/Dropdown';
import Alert from 'react-bootstrap/Alert';

const QueryTable = (props) => {
  const [input, setInput] = useState("")
  const [entities, setEntities] = useState(null)
  const [text, setText] = useState("")
  const [keyword, setKeyword] = useState("")
  const [label1, setLabel1] = useState("")
  const [label2, setLabel2] = useState("")
  const [isBusy, setIsBusy] = useState(false);
  const [notFoundText, setNotFound] = useState('');
  const [topanswer, setTopanswer] = useState(null)
  const [pageno, setPageno] = useState("");
  const projectId = props.project_id;
  const projectType = props.project_type;
  const routestypes = {
    'ediscovery': {
      main_path: '/ediscovery',
      file_path: '/filesediscovery/',
      main_path_breadcrumb: 'eDiscovery'
    },
    'contractreview': {
      main_path: '/contractreview',
      file_path: '/filescontractreview/',
      main_path_breadcrumb: 'Contract Review'
    },
    'caselawsearch': {
      main_path: '/caselawsearch',
      file_path: '/filescaselawsearch/',
      main_path_breadcrumb: 'Case Law Search'
    }
  }
  const questionstypes = {
    'ediscovery': {
      project: projectId.toUpperCase(),
      question: 'What event was Jeff asked to speak at in France?'
    },
    'contractreview': {
      project: projectId.toUpperCase(),
      question: 'Force Majeure clauses'
    },
    'caselawsearch': {
      project:projectId.toUpperCase(),
      question: 'Fraudulent tax accounting services'
    }
  }
  const [errorMessage, setErrorMessage] = useState('');


  const search = async (e) => {
    setIsBusy(true);
    setNotFound('');
    setKeyword(e.input);
    setTopanswer(null)
    setEntities([])
    setLabel1("")
    setLabel2("")
    // setEntities(result)
    const user = await Auth.currentAuthenticatedUser();
    const requestInfo = { headers: { Authorization: user.signInUserSession.idToken.jwtToken } }
    API.get("DocumentSearchUser", `/querysearch?projectid=${projectId}&keyword=${e.input}`, requestInfo)
      .then(response => {
        setErrorMessage('');
        setIsBusy(false);
        console.log('response');

        console.log(response);
        setEntities(response.items.items.other_answers)
        setTopanswer(response.items.items.top_answer)
        props.onSearch(response.report_id)
        if (response.items.items.other_answers.length == 0 && response.items.items.top_answer == undefined) {
          setNotFound('No results found!');
        }
        if (response.items.items.top_answer == undefined) {
          setLabel1("")
        }
        else {
          setLabel1("Best Answer")
        }
        if (response.items.items.other_answers == undefined || response.items.items.other_answers.length == 0) {
          setLabel2("")
        }
        else {
          setLabel2("Answers")
        }


      })
      .catch(error => {
        setIsBusy(false);
        console.log(error);
        if (error.response.status == 406) {
          setErrorMessage(error.response.data);
      }
      })
  };

  const handleDetail = async (entity) => {
    console.log(entity);
    setPageno('')
    setIsBusy(true);
    const user = await Auth.currentAuthenticatedUser()
    const requestInfo = { headers: { Authorization: user.signInUserSession.idToken.jwtToken } }
    console.log(projectId)
    API.get('DocumentSearchUser', '/getfilecontent' + `?projectid=${projectId}&filename=${entity.document}&page=${entity.page[0]}&keyword=${entity.highlight_phrase}`, requestInfo)//
      .then(response => {
        console.log(response);
        if (response.text === '') {
          console.log('entity')
          console.log(entity)
          setText(entity.highlight)
          setPageno(`No page available for selected answer`)
        }
        else {
          setText(response.text);
          setPageno(`Page ${response.page_no} of ${response.no_pages}`)
        }
        setIsBusy(false);
      })
      .catch(error => {
        setIsBusy(false);
        console.log(error);
      })
    setText(entity.text)
  };
  const setSampleQuestion = () => {
    setInput(questionstypes[projectType]['question'])
    //input = questionstypes[projectType]['question'];
    console.log("WORKS")
  };

  return (
    <>
      <Row>
        <Col>
          <br />
          <Breadcrumb>
            {<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>}
            {<Breadcrumb.Item linkAs={Link} linkProps={{ to: routestypes[projectType]['main_path'] }}>{routestypes[projectType]['main_path_breadcrumb']}</Breadcrumb.Item>}
            {<Breadcrumb.Item linkAs={Link} linkProps={{ to: routestypes[projectType]['file_path'] + "?projectid=" + projectId }}>{projectId}</Breadcrumb.Item>}
            <Breadcrumb.Item active>Query</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col>
          <h1>Query Search</h1>
        </Col>
      </Row>
      <Row className='my-4'>
        <Col>
          <div className='text-center'>
            <Dropdown>
              <Dropdown.Toggle variant="secondary">
                Example Search Query
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setSampleQuestion()}>
                  <div style={{ whiteSpace: 'pre-line'}}>
                    {questionstypes[projectType]['project']+' \n'}{questionstypes[projectType]['question']}
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm="5">
          <InputGroup className="mb-3">
            <FormControl
              placeholder="enter search phrase"
              aria-label="enter search phrase"
              aria-describedby="basic-addon2"
              value={input} onChange={(e) => setInput(e.target.value)}
            />
            <Button variant="outline-secondary" id="button-addon2" onClick={() => search({ input })}>
              <Search />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
      <Row style={{ 'marginTop': '1em' }} >
                <Col>
                    {errorMessage && (
                        <Alert key="danger" variant="danger">
                            {errorMessage}
                        </Alert>
                    )}
                </Col>
            </Row>
      <Row>
        <Col>
          <div key={entities?.user_id} className="float-child">
            <div style={{ "height": "50vh", "overflow-x": "hidden", "overflow-y": "auto" }}>
              <h5 style={{ color: 'red' }}>{notFoundText}</h5>
              <h3>{label1}</h3>
              <Table>
                <tbody>
                  {(topanswer != null &&
                    <QueryRow key="top_answer" entity={topanswer} projectId={projectId} OnDetail={handleDetail} />
                  )}
                </tbody>
              </Table>
              <h3>{label2}</h3>
              <Table>
                <tbody>
                  {
                    entities != null &&

                    entities?.map((thisEntity, index) => {
                      return (
                        <QueryRow key={index} entity={thisEntity} projectId={projectId} OnDetail={handleDetail} />
                      )
                    })
                  }
                </tbody>
              </Table>
            </div>
          </div>
          <div className="float-child">
            <div id='doctextarea' style={{ "width": "100%", "height": "50vh", "padding": "20px", "overflow-y": "auto" }} readOnly dangerouslySetInnerHTML={{ __html: text }}></div>
            <div style={{ textAlign: 'right' }}>
              {pageno}
            </div>
          </div>

        </Col>
      </Row>
    </>
  )
}
export default QueryTable;